import type { ColumnDef } from '@tanstack/react-table';
import type { RouterOutputs } from '~/trpc-extra/api';
import { VariableValueCell } from './variableValueCell';

export const projectVariableColumns: ColumnDef<RouterOutputs['variable']['list'][number] & { value: string }>[] = [
  {
    header: 'Name',
    accessorFn: (row) => row.name,
    cell: ({ row }) => {
      return (
        <div className="py-2">
          <span className="break-all text-sm font-medium text-gray-900 dark:text-gray-100">{row.original.name}</span>
        </div>
      );
    },
  },
  {
    header: 'Value',
    accessorFn: (row) => row.value,
    cell: ({ row }) => {
      return (
        <VariableValueCell
          name={row.original.name}
          value={row.original.value}
          parseAsJson={true}
        />
      );
    },
  },
];
